import { Footer } from '@liveauctioneers/hammer-ui-liveauctioneers/footer';
import { en } from '@liveauctioneers/hammer-ui-liveauctioneers/intl/en';
import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { EventContext } from '@/redux/modules/analytics';
import { getBaseUrl, getPartnersBaseUrl } from '@/redux/modules/config';
import {
    CompleteAccountModalContext,
    openCompleteAccountSignUpModal,
    openFeedbackModal,
    openLoginModal,
} from '@/redux/modules/modal';
import { getIsWhiteLabel, getWhiteLabelName } from '@/redux/modules/whiteLabel';
import {
    HowToWinLinkLocation,
    useTrackHowToWinClickedAnalytics,
} from '@/utils/amplitude/analytics/howToWin/trackHowToWinClicked.analytics';
import { getAuctionCalendarBaseUrl, getItemIdFromPath } from '@/utils/urls';

export const HammerFooter = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const baseUrl = useAppSelector(getBaseUrl);
    const isWhiteLabel = useAppSelector(getIsWhiteLabel);
    const whiteLabelName = useAppSelector(getWhiteLabelName);
    const partnersBaseUrl = useAppSelector(getPartnersBaseUrl);
    const showFeedbackModal = useCallback(() => dispatch(openFeedbackModal()), [dispatch]);
    const { pathname } = useLocation();
    const itemId = getItemIdFromPath(pathname);

    const trackHowToWinClicked = useTrackHowToWinClickedAnalytics();

    const onLoginClicked = useCallback(
        () =>
            dispatch(
                openLoginModal({
                    eventContext: EventContext.join,
                    id: itemId,
                    itemId,
                    type: CompleteAccountModalContext.Login,
                })
            ),
        [dispatch, itemId]
    );

    const onSignUpClicked = useCallback(() => {
        dispatch(
            openCompleteAccountSignUpModal({
                eventContext: EventContext.join,
                id: itemId,
                itemId,
                type: CompleteAccountModalContext.Join,
            })
        );
    }, [dispatch, itemId]);

    const props = {
        baseUrl,
        intl: en,
        isWhiteLabel,
        openFeedbackModal: showFeedbackModal,
        partnersBaseUrl,
        whiteLabelName,
    };

    return (
        <Footer
            callbacks={{
                onHowToWinClicked: () => {
                    trackHowToWinClicked(HowToWinLinkLocation.Footer);
                },
            }}
            isUserLoggedIn={userLoggedIn}
            onBrowseAuctionsClicked={() => {
                navigate(getAuctionCalendarBaseUrl());
            }}
            onLoginClicked={onLoginClicked}
            onSignUpClicked={onSignUpClicked}
            {...props}
        />
    );
};
